import { logger } from "./logger";
import { clearSignupLocation, getSignupLocation } from "./storage";

export const trackBeginCheckout = (config: {
  currency: string;
  value: number;
  item_id: string;
  item_name: string;
}) => {
  const { currency, value, item_id, item_name } = config;
  window.gtag("event", "begin_checkout", {
    currency,
    value,
    items: [
      {
        item_id,
        item_name,
      },
    ],
  });
};

export const trackCheckoutComplete = (orderCompleteData: any) => {
  const couponCode =
    orderCompleteData.coupons?.length > 0 ? orderCompleteData.coupons[0] : "";
  const awinCommissionGroupCode =
    orderCompleteData.items[0]?.attributes?.awinCommissionGroupCode ||
    "DEFAULT";

  const gtagData = {
    event: "fastspring-checkout-complete",
    ecommerce: {
      purchase: {
        actionField: {
          id: orderCompleteData.reference,
          revenue: orderCompleteData.totalInPayoutCurrency,
          revenueSubtotal: parseFloat(
            orderCompleteData.subtotalInPayoutCurrency,
          ).toFixed(2),
          currencyCode: orderCompleteData.payoutCurrency,
          coupon: couponCode,
          awinCommissionGroupCode,
        },
      },
      products: [],
    },
  };

  gtagData.ecommerce.products = orderCompleteData.items.map((item: any) => {
    return {
      name: item.product,
      id: item.sku,
      dimension1: orderCompleteData.account,
      price: item.subtotalInPayoutCurrency,
      category: "videoscribe",
      quantity: item.quantity,
    };
  });

  window.gtag("event", gtagData.event, gtagData.ecommerce);
};

export const trackBuyButtonClick = (
  productPath: string,
  isLoggedIn: boolean,
) => {
  window.gtag("event", "select_item", {
    logged_in: isLoggedIn,
    items: [
      {
        item_id: productPath,
      },
    ],
  });
};

export const trackRegisterEmail = () =>
  new Promise<void>((resolve) => {
    const signupLocation = getSignupLocation();

    window.gtag("event", "register_email", {
      signup_location: signupLocation,
      event_callback: () => {
        logger("[GOOGLE] Tracking register email complete");
        resolve();
      },
    });
  });

export const trackSignup = (provider: string) =>
  new Promise<void>((resolve) => {
    const signupLocation = getSignupLocation();

    window.gtag("event", "sign_up", {
      signup_provider: provider,
      signup_location: signupLocation,
      event_callback: () => {
        clearSignupLocation();
        logger("[GOOGLE] Tracking signup complete");
        resolve();
      },
    });
  });

const trackGoogleSignupAsync = () =>
  new Promise<void>((resolve) => {
    window.gtag("event", "signup_with_google", {
      signup_location: window.location.pathname,
      event_callback: () => resolve(),
    });
  });

export const trackGoogleSignupWithTimeout = async () => {
  try {
    await Promise.all([
      trackGoogleSignupAsync(),
      new Promise((resolve) => setTimeout(resolve, 500)),
    ]);
  } catch (error) {
    console.error("Error tracking Google signup:", error);
  }
};

const trackClickedCreateAccountAsync = () =>
  new Promise<void>((resolve) => {
    window.gtag("event", "clicked_create_account", {
      signup_location: window.location.pathname,
      event_callback: () => resolve(),
    });
  });

export const trackClickedCreateAccountWithTimeout = async () => {
  try {
    await Promise.all([
      trackClickedCreateAccountAsync(),
      new Promise((resolve) => setTimeout(resolve, 500)),
    ]);
  } catch (error) {
    console.error("Error tracking clicked create account:", error);
  }
};

export const trackEmailConfirmLinkExpired = () => {
  window.gtag("event", "Email Confirm Link Expired");
};
